const MAX_VISIBLE_DETAILS = 3;

const TRACKING = 'CHECKOUT';

export { MAX_VISIBLE_DETAILS, TRACKING };
